import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgSettings = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M9 12c1.655 0 3-1.345 3-3 0-1.654-1.345-3-3-3-1.654 0-3 1.346-3 3 0 1.655 1.346 3 3 3Zm0-4.5c.813 0 1.5.687 1.5 1.5s-.687 1.5-1.5 1.5A1.52 1.52 0 0 1 7.5 9c0-.813.687-1.5 1.5-1.5Z"
      fill="#6C6C8A"
    />
    <path
      d="m2.134 12.102.75 1.297c.398.688 1.357.946 2.047.548l.397-.23c.434.342.913.622 1.422.835V15c0 .827.673 1.5 1.5 1.5h1.5c.828 0 1.5-.673 1.5-1.5v-.448c.51-.213.988-.493 1.422-.834l.397.23c.692.397 1.648.14 2.048-.549l.75-1.296a1.5 1.5 0 0 0-.549-2.05l-.378-.218a5.79 5.79 0 0 0 0-1.668l.378-.22a1.501 1.501 0 0 0 .549-2.048l-.75-1.297c-.398-.69-1.356-.949-2.048-.549l-.397.23a6.075 6.075 0 0 0-1.422-.835V3c0-.827-.672-1.5-1.5-1.5h-1.5c-.827 0-1.5.673-1.5 1.5v.449c-.51.212-.988.492-1.422.833l-.397-.23c-.693-.398-1.65-.14-2.048.55l-.749 1.296a1.5 1.5 0 0 0 .548 2.049l.379.219a5.762 5.762 0 0 0 0 1.667l-.379.22a1.502 1.502 0 0 0-.548 2.049Zm2.494-2.069a4.277 4.277 0 0 1 0-2.066.75.75 0 0 0-.353-.831l-.842-.488.748-1.297.86.497a.748.748 0 0 0 .89-.107A4.553 4.553 0 0 1 7.72 4.692a.75.75 0 0 0 .531-.717V3h1.5v.975a.75.75 0 0 0 .531.717c.669.208 1.28.567 1.788 1.05a.75.75 0 0 0 .891.106l.858-.496.75 1.297-.843.487a.75.75 0 0 0-.352.83 4.28 4.28 0 0 1 0 2.067.75.75 0 0 0 .352.832l.843.486-.749 1.297-.859-.496a.747.747 0 0 0-.89.107 4.553 4.553 0 0 1-1.789 1.049.75.75 0 0 0-.53.717V15h-1.5v-.975a.75.75 0 0 0-.532-.717 4.561 4.561 0 0 1-1.788-1.05.745.745 0 0 0-.89-.105l-.859.496-.75-1.296.843-.489a.75.75 0 0 0 .353-.83Z"
      fill="#6C6C8A"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSettings);
export default ForwardRef;
